import { Component, OnInit, Input } from '@angular/core';
import { LoginService } from '../../services/auth/login.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreConfigService } from '../../services/config/core-config.service';
import { AppSettingService } from '../../services/service/app-setting.service';
import { SessionStorageService } from 'ngx-webstorage';
import { NzModalService } from 'ng-zorro-antd';

@Component({
    selector: 'zx-login',
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    @Input("app-title") appTitle: string;
    @Input("loginSuccess") loginSuccess: Function;
    @Input("loginFail") loginFail: Function;

    private _defaultAppTitle = "跨境电商智慧生态 - 登录系统";
    constructor(
        private loginService: LoginService,
        private activatedRoute: ActivatedRoute,
        private configService: CoreConfigService,
        private router: Router,
        private appSettingService: AppSettingService,
        private titleService: Title,
        private sessionStorage: SessionStorageService,
        private modalService: NzModalService
    ) {
    }

    ngOnInit() {
        const config = this.configService.loginPage || {};
        this.loginSuccess = this.loginSuccess || config.loginSuccess;
        this.loginFail = this.loginFail || config.loginFail;
        this.titleService.setTitle(this._defaultAppTitle);
        this.loginForQrcode();
    }

    openLoginModal() {
        this.loginService.loginByModal();
    }

    loginForQrcode() {
        let code = this.getQueryString('code') || this.activatedRoute.snapshot.queryParams['code'];
        if (!code) return;
        let loginInfo: any = {
            grant_type: 'open_auth',
            action: 'action_login',
            auth_type: 'WEIXIN_WEB_APP'
        };
        loginInfo.auth_temp_key = code;
        this.login(loginInfo);
    }

    private getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
        if (r != null) return unescape(r[2]); return null;
    }

    login(loginVaue) {
        this.loginService.login(loginVaue).then((account) => {
            if (this.loginSuccess) {
                try {
                    this.loginSuccess(account, this.router);
                    return;
                } catch (ex) { }
            }
            // window.location.href = '/gmp';
            if (this.sessionStorage.retrieve('currentRouter') && this.sessionStorage.retrieve('currentRouter') == '/login') {
                this.router.navigate(['/apps']);
            } else if (this.sessionStorage.retrieve('currentRouter') && this.sessionStorage.retrieve('currentRouter') != '/login') {
                this.router.navigate([this.sessionStorage.retrieve('currentRouter')]);
            }
            this.clearQueryParam();
        }).catch((error) => {
            this.clearQueryParam();
            this.loginService.loginByModal(true, error);
            if (this.loginFail) {
                try { this.loginFail(error, this.router); } catch (ex) { }
            }
        });
    }

    downloadAppPackage() {
        this.modalService.confirm({
            nzTitle: '是否下载跨境电商浏览器？',
            nzOnOk: () => {
                const appPackageUrl = this.appSettingService.baseClientAppPackageDownloadUrl;
                if (appPackageUrl) {
                    window.location.href = appPackageUrl;
                }
            }
        });
    }

    private clearQueryParam() {
        let url = window.location.href;                    //获取当前页面的url
        if (url.indexOf("?") != -1) {                        //判断是否存在参数
            url = url.replace(/(\?|#)[^'"]*/, '');           //去除参数
            window.history.pushState({}, '', url);
        }
    }
}